import { CrudState } from "@/store/Crud/State";
export class State extends CrudState {
    selectedTheoryStudentEducation = {};
    selectedPreExamStudentEducation = {};
    selectedAccountStudentEducation = {};
    selectedPlaygroundStudentEducation = {};
    learningMode = null;
}
